module.exports = __webpack_public_path__ + "static/media/55439561_2519303181478191_947955962910605312_o.4707fa8e.jpg";